import BaseInput from './BaseInput'

export default class FloatIput extends BaseInput {
  parse = (v) => {
    const parsed = parseFloat(v)
    return Number.isNaN(parsed) ? undefined : parsed
  }

  inputProps = () => ({ type: 'number' })
}
